"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupHandler = void 0;
var util_1 = require("../util");
function GroupHandler(cacheControl, send, templateHandler, widgetHandler) {
    var queueable = util_1.Queueable('getAll', 'get', 'getMany');
    var countLatch = false;
    var self = {
        whereIsItUsed: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var result, output, _a, _b, _i, i, _c, _d, _e, _f, _g, i, _h, _j, _k, _l, _m, i, _o, _p;
                return __generator(this, function (_q) {
                    switch (_q.label) {
                        case 0: return [4, send({
                                url: "/group/" + id + "/where-is-it-used",
                                method: 'GET',
                                headers: {
                                    Authorization: '',
                                },
                            })];
                        case 1:
                            result = _q.sent();
                            output = {
                                groups: [],
                                templates: [],
                                widgets: [],
                            };
                            _a = [];
                            for (_b in result.templateIds)
                                _a.push(_b);
                            _i = 0;
                            _q.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3, 5];
                            i = _a[_i];
                            _d = (_c = output.templates).push;
                            return [4, templateHandler.get(result.templateIds[i])];
                        case 3:
                            _d.apply(_c, [_q.sent()]);
                            _q.label = 4;
                        case 4:
                            _i++;
                            return [3, 2];
                        case 5:
                            _e = [];
                            for (_f in result.groupIds)
                                _e.push(_f);
                            _g = 0;
                            _q.label = 6;
                        case 6:
                            if (!(_g < _e.length)) return [3, 9];
                            i = _e[_g];
                            _j = (_h = output.groups).push;
                            return [4, self.get(result.groupIds[i])];
                        case 7:
                            _j.apply(_h, [_q.sent()]);
                            _q.label = 8;
                        case 8:
                            _g++;
                            return [3, 6];
                        case 9:
                            _k = [];
                            for (_l in result.widgetIds)
                                _k.push(_l);
                            _m = 0;
                            _q.label = 10;
                        case 10:
                            if (!(_m < _k.length)) return [3, 13];
                            i = _k[_m];
                            _p = (_o = output.widgets).push;
                            return [4, widgetHandler.get(result.widgetIds[i])];
                        case 11:
                            _p.apply(_o, [_q.sent()]);
                            _q.label = 12;
                        case 12:
                            _m++;
                            return [3, 10];
                        case 13: return [2, output];
                    }
                });
            });
        },
        getAll: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, queueable.exec('getAll', 'first_done_free_all', function () { return __awaiter(_this, void 0, void 0, function () {
                                var groups, count, result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            groups = cacheControl.group.getAll();
                                            if (!(countLatch === false)) return [3, 2];
                                            countLatch = true;
                                            return [4, this.count()];
                                        case 1:
                                            count = _a.sent();
                                            if (count === groups.length) {
                                                return [2, groups];
                                            }
                                            return [3, 3];
                                        case 2:
                                            if (groups.length > 0) {
                                                return [2, groups];
                                            }
                                            _a.label = 3;
                                        case 3: return [4, send({
                                                url: '/group/all',
                                                method: 'GET',
                                                headers: {
                                                    Authorization: '',
                                                },
                                            })];
                                        case 4:
                                            result = _a.sent();
                                            result.groups.forEach(function (group) {
                                                cacheControl.group.set(group);
                                            });
                                            return [2, result.groups];
                                    }
                                });
                            }); })];
                        case 1: return [2, (_a.sent())];
                    }
                });
            });
        },
        get: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, queueable.exec('get', 'free_one_by_one', function () { return __awaiter(_this, void 0, void 0, function () {
                                var group, result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            group = cacheControl.group.get(id);
                                            if (group) {
                                                return [2, group];
                                            }
                                            return [4, send({
                                                    url: "/group/" + id,
                                                    method: 'GET',
                                                    headers: {
                                                        Authorization: '',
                                                    },
                                                })];
                                        case 1:
                                            result = _a.sent();
                                            cacheControl.group.set(result.group);
                                            return [2, result.group];
                                    }
                                });
                            }); })];
                        case 1: return [2, (_a.sent())];
                    }
                });
            });
        },
        getMany: function (ids) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, queueable.exec('getMany', 'free_one_by_one', function () { return __awaiter(_this, void 0, void 0, function () {
                                var groups, missingIds, _loop_1, i, result, i;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(countLatch === false)) return [3, 2];
                                            return [4, this.getAll()];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2:
                                            groups = cacheControl.group.find(function (e) { return ids.includes(e._id); });
                                            if (!(groups.length !== ids.length)) return [3, 4];
                                            missingIds = [];
                                            _loop_1 = function (i) {
                                                var g = groups.find(function (e) { return e._id === ids[i]; });
                                                if (!g) {
                                                    missingIds.push('' + ids[i]);
                                                }
                                            };
                                            for (i in ids) {
                                                _loop_1(i);
                                            }
                                            return [4, send({
                                                    url: "/group/many/" + missingIds.join('-'),
                                                    method: 'GET',
                                                    headers: {
                                                        Authorization: '',
                                                    },
                                                })];
                                        case 3:
                                            result = _a.sent();
                                            for (i in result.groups) {
                                                cacheControl.group.set(result.groups[i]);
                                                groups.push(JSON.parse(JSON.stringify(result.groups[i])));
                                            }
                                            _a.label = 4;
                                        case 4: return [2, groups];
                                    }
                                });
                            }); })];
                        case 1: return [2, (_a.sent())];
                    }
                });
            });
        },
        count: function () {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, send({
                                url: '/group/count',
                                method: 'GET',
                                headers: {
                                    Authorization: '',
                                },
                            })];
                        case 1:
                            result = _a.sent();
                            return [2, result.count];
                    }
                });
            });
        },
        add: function (data) {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, send({
                                url: '/group',
                                method: 'POST',
                                headers: {
                                    Authorization: '',
                                },
                                data: data,
                            })];
                        case 1:
                            result = _a.sent();
                            cacheControl.group.set(result.group);
                            return [2, result.group];
                    }
                });
            });
        },
        update: function (data) {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, send({
                                url: '/group',
                                method: 'PUT',
                                headers: {
                                    Authorization: '',
                                },
                                data: data,
                            })];
                        case 1:
                            result = _a.sent();
                            cacheControl.group.set(result.group);
                            return [2, result.group];
                    }
                });
            });
        },
        deleteById: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, send({
                                url: "/group/" + id,
                                method: 'DELETE',
                                headers: {
                                    Authorization: '',
                                },
                            })];
                        case 1:
                            _a.sent();
                            cacheControl.group.remove(id);
                            return [2];
                    }
                });
            });
        },
    };
    return self;
}
exports.GroupHandler = GroupHandler;
//# sourceMappingURL=group.js.map